import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { CustomAutocompleteProps } from './types';

export function CustomAutocomplete<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  placeholder = 'Select...',
  textFieldProps,
  error,
  helperText,
  loading,
  stopKeyPropagation = true,
  ...autocompleteProps
}: CustomAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Autocomplete
      size="small"
      loading={loading}
      {...autocompleteProps}
      renderInput={params => (
        <TextField
          {...params}
          {...textFieldProps}
          placeholder={placeholder}
          size="small"
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            ...textFieldProps?.InputProps,
            onKeyDown: e => {
              // Only stop propagation if explicitly requested via prop
              // By default, allow propagation (needed for freeSolo Enter key handling)
              if (stopKeyPropagation) {
                e.stopPropagation();
              }
              textFieldProps?.InputProps?.onKeyDown?.(e);
            },
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
